import { TokenCheckUrl } from '../constants';
import { RequestHeaders } from './utilities';
export function checkToken(api) {
  return function () {
    return api.authenticated().get(TokenCheckUrl, {}, RequestHeaders);
  };
}